import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { ShopErrorModal } from "./component";
import {
  getPremierCollectionShopSelectedAvailability,
  hasPremierCollectionShopFailed,
  isMissingPayNowRates,
  isMissingProductInfo,
} from "../../reducer/selectors";
import { fetchPremierCollectionShop } from "../../actions/actions";
import { IStoreState } from "../../../../reducers/types";
import {
  getAdultsCount,
  getChildrenCount,
  getFromDate,
  getUntilDate,
} from "../../../search/reducer";

const mapStateToProps = (state: IStoreState) => ({
  hasFailed: hasPremierCollectionShopFailed(state),
  missingRoomProductInfo: isMissingProductInfo(state),
  isMissingPayNowRates: isMissingPayNowRates(state),
  lodging: getPremierCollectionShopSelectedAvailability(state),
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  adultsCount: getAdultsCount(state),
  childrenCount: getChildrenCount(state),
});

const mapDispatchToProps = {
  fetchPremierCollectionShop,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ShopErrorModalConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedShopErrorModal = withRouter(connector(ShopErrorModal));
